<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="itemsToShow && !loading">
				<tr *ngFor="let item of itemsToShow" [routerLink]="[item.id]" class="cp-pointer"
					[ngClass]="{'text-danger': item.is_enabled === 0}">
					<td class="cp-icon-cell">
						<fa-icon *ngIf="item.is_enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success"
							ngbTooltip="Enabled" placement="end"></fa-icon>
						<fa-icon *ngIf="item.is_enabled === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger" ngbTooltip="Disabled"
							placement="end"></fa-icon>
					</td>
					<td>
						<a [routerLink]="[item.id]" [ngbPopover]="zmPopupContent" popoverClass="cp-popover-std"
							triggers="mouseenter:mouseleave" container="body">
							{{ item.dns_prefix }}
						</a>
					</td>
					<td>
						<a [routerLink]="[item.id]" [ngbPopover]="zmPopupContent" popoverClass="cp-popover-std"
							triggers="mouseenter:mouseleave" container="body">
							{{ item.name}}
						</a>
					</td>
					<td class="text-nowrap text-center">
						<span [class]="'cp-zen-type-' + item.zcp_type">
							{{ item['__zenType'] }}
						</span>
					</td>
					<td class="text-nowrap text-center">{{ item.assessment }}</td>

					<td class="cp-icon-cell">
						<fa-icon *ngIf="item['__notifyWarning']" [icon]="['fas', 'exclamation-triangle']" size="sm" class="text-warning"
							ngbTooltip="None of this site's users are setup to receive ZEN Master notifications from the portal">
						</fa-icon>
						<fa-icon *ngIf="!item['__notifyWarning']" [icon]="['fas', 'check']" size="sm" class="text-success"
							ngbTooltip="At least one of this site's users is setup to receive ZEN Master notifications from the portal">
						</fa-icon>
					</td>

					<td>{{ item['__orgName'] }}</td>

					<td class="cp-icon-cell text-center" [title]="item['__accountOwner']">
						{{ item['__accountOwnerShort'] }}
					</td>
					<td class="cp-icon-cell text-center" [title]="item['__se']">
						{{ item['__seShort'] }}
					</td>
					<td class="cp-icon-cell text-center" [title]="item['__se']">
						{{ item['__tamShort'] }}
					</td>
					<td class="cp-icon-cell text-center" [title]="item['__sa']">
						{{ item['__saShort'] }}
					</td>
					<td class="text-nowrap text-end">
						{{ displayDays(item.created_days) }}
					</td>
					<td class="text-nowrap text-end">
						{{ displayDays(item.last_login_days) }}
					</td>

					<td class="text-nowrap text-end">
						{{ item.is_enabled ? tt.formattedMB(item['__zenUsage']) : 'n/a'}}
					</td>
					<td *ngIf="item.is_enabled === 1" class="text-nowrap text-end">
						{{ item.is_enabled ? tt.formattedMB(item['__mcUsage']) : 'n/a'}}
					</td>

					<td class="text-nowrap text-end">{{ item.num_active_bx }}</td>

					<td class="cp-icon-cell">
						<fa-icon *ngIf="item['__marketplace'] !== ''" [icon]="ac.sectionIcons.marketplace" size="sm" placement="start"
							[ngbTooltip]="item['__marketplace']">
						</fa-icon>
					</td>

					<ng-template #zmPopupContent>
						<app-card-zen-master [object]="item"></app-card-zen-master>
					</ng-template>

				</tr>
			</tbody>
		</table>

		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>